import { makeStyles } from "@mui/styles";
export const useMarkdownStyles = makeStyles((theme) => {
    return {
        markdownEl: (props) => ({
            width: "100%",
            color: props.isTopBar ? theme.palette.getContrastText(props.bgColor) : undefined,
            marginBottom: 0,
            "& *": {
                color: props.isTopBar ? theme.palette.getContrastText(props.bgColor) : undefined,
                marginBottom: 0,
            },
            "& a:hover": {
                color: props.isTopBar ? theme.palette.getContrastText(props.bgColor) : undefined,
            },
            "& table": {
                "& tr": {
                    display: "flex",
                    justifyContent: "space-between",
                    "&>td:only-of-type": {
                        display: "flex",
                        flexGrow: 1,
                        "&[style*='text-align: left']": {
                            justifyContent: "flex-start",
                        },
                        "&[style*='text-align: center']": {
                            justifyContent: "center",
                        },
                        "&[style*='text-align: right']": {
                            justifyContent: "flex-end",
                        },
                    },
                },
                "& th, & td": {
                    "&:empty": {
                        display: "none",
                    },
                    padding: theme.spacing(1),
                    border: "none",
                    "& a": props.isTopBar
                        ? {
                            padding: theme.spacing(1),
                            "&:first-of-type": {
                                paddingLeft: 0,
                            },
                            "&:last-of-type": {
                                paddingRight: 0,
                            },
                        }
                        : undefined,
                    "&[style*='text-align: left']": {
                        paddingLeft: 0,
                    },
                    "&[style*='text-align: right']": {
                        paddingRight: 0,
                    },
                },
            },
            [theme.breakpoints.down("sm")]: {
                "& table": {
                    "& tr": {
                        flexFlow: "column",
                        alignItems: "center",
                    },
                },
            },
        }),
    };
});
